import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import SupportedLiving from "./pages/SupportedLiving";
import Staffing from "./pages/Staffing";
import Recruitment from "./pages/Recruitment";
import About from "./pages/About";
import Compliance from "./pages/Compliance";
import Contact from "./pages/Contact";
import CookiePolicy from "./pages/CookiePolicy";

// Compliance Pages
import SafeguardingAdults from "./pages/compliance/SafeguardingAdults";
import Complaints from "./pages/compliance/Complaints";
import DutyOfCandour from "./pages/compliance/DutyOfCandour";
import PrivacyNotice from "./pages/compliance/PrivacyNotice";
import EqualityDiversity from "./pages/compliance/EqualityDiversity";
import GovernanceQuality from "./pages/compliance/GovernanceQuality";
import CQCStatus from "./pages/compliance/CQCStatus";

function App() {
  return (
    <div className="App">
      <style dangerouslySetInnerHTML={{__html: `
        /* Hide Emergent badge - target by ID and attributes */
        #emergent-badge,
        button[style*="position"][style*="fixed"],
        button[style*="position: fixed"],
        div[style*="position: fixed"][style*="bottom"][style*="right"],
        [style*="z-index: 999999"],
        [style*="z-index: 99999"],
        [id*="emergent"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }
      `}} />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/supported-living" element={<SupportedLiving />} />
          <Route path="/staffing" element={<Staffing />} />
          <Route path="/recruitment" element={<Recruitment />} />
          <Route path="/about" element={<About />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          
          {/* Compliance Sub-pages */}
          <Route path="/compliance/safeguarding-adults" element={<SafeguardingAdults />} />
          <Route path="/compliance/complaints" element={<Complaints />} />
          <Route path="/compliance/duty-of-candour" element={<DutyOfCandour />} />
          <Route path="/compliance/privacy-notice" element={<PrivacyNotice />} />
          <Route path="/compliance/equality-diversity" element={<EqualityDiversity />} />
          <Route path="/compliance/governance-quality" element={<GovernanceQuality />} />
          <Route path="/compliance/cqc-status" element={<CQCStatus />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
